











































































































































import Vue from 'vue'
import Redactor from '../../../components/Redactor.vue'
import DialogComponent from '../../../components/Modal.vue'
import FormCreator from './FormCreator.vue'
import FormTopic from './FormTopic.vue'
import FormViewer from './FormViewer2.vue'
import UploadPhoto from './UploadPhoto.vue'
import CropPhoto from './CropPhoto.vue'
import ColorInput from '../ColorInput.vue'

export default Vue.extend({
    props: ['settings'],
    components: {
        Redactor,
        FormCreator,
        FormTopic,
        FormViewer,
        ColorInput,
        DialogComponent,
        UploadPhoto,
        CropPhoto
    },
    data() {
        return {
            colors_button: { hex: this.settings.form_color_button, a: this.settings.form_color_button_opacity },
            colors_text: { hex: this.settings.form_color_text, a: this.settings.form_color_text_opacity },
            colors_background_success: { hex: this.settings.form_bg_success, a: this.settings.form_bg_success_opacity },
            colors_text_success: { hex: this.settings.form_tx_success, a: this.settings.form_tx_success_opacity },
            colors_background_error: { hex: this.settings.form_bg_error, a: this.settings.form_bg_error_opacity },
            colors_text_error: { hex: this.settings.form_tx_error, a: this.settings.form_tx_error_opacity },
            topicDialog: false,
            cropDialog: false,
            photoUrl: ''
        }
    },
    methods: {
        updateButtonColor(colors: any) {
            this.settings.form_color_button = colors.hex
            this.settings.form_color_button_opacity = colors.a
            this.colors_button = colors
        },
        updateTextColor(colors: any) {
            this.settings.form_color_text = colors.hex
            this.settings.form_color_text_opacity = colors.a
            this.colors_text = colors
        },
        updateBgSsColor(colors: any) {
            this.settings.form_bg_success = colors.hex
            this.settings.form_bg_success_opacity = colors.a
            this.colors_background_success = colors
        },
        updateTxSsColor(colors: any) {
            this.settings.form_tx_success = colors.hex
            this.settings.form_tx_success_opacity = colors.a
            this.colors_text_success = colors
        },
        updateBgErColor(colors: any) {
            this.settings.form_bg_error = colors.hex
            this.settings.form_bg_error_opacity = colors.a
            this.colors_background_error = colors
        },
        updateTxErColor(colors: any) {
            this.settings.form_tx_error = colors.hex
            this.settings.form_tx_error_opacity = colors.a
            this.colors_text_error = colors
        },
        uploadPhoto(url: string) {
            this.photoUrl = url
            this.cropDialog = true
        }
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/form/Form.vue